<template>
  <div class="publicHall">
    <NavBar/>
    <header class="title">发布的展馆</header>
    <pavilion-list @clickPavilion="BrowsePavilion"/>
  </div>
</template>

<script>
import PavilionList from "@/components/PavilionList.vue";
import NavBar from "@/components/NavBar";
import { Toast } from "vant";
export default {
  components: {
    NavBar,
    PavilionList,
    [Toast.name]: Toast
  },
  methods: {
    BrowsePavilion(item, total, page, pageSize) {
      if (item.gems.length === 0) {
        Toast("没有布置展馆");
        return;
      }
      this.$router.push({
        path: `/pavilion-view/${item.id}`
      });
    }
  }
};
</script>

<style scoped lang="less">
.publicHall {
  .title {
    font-size: 21px;
    font-weight: 800;
    color: rgba(65, 65, 65, 1);
    margin: 23px 0;
    padding-left: 19px;
    text-align: left;
  }
}
</style>